import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { EmptyComponent } from '@app/empty/empty.component';
import { EFeatureFlag } from '@app/feature-toggle-list';
import { DefectiveReportsComponent } from '@app/modules/inventory/defective-reports/defective-reports.component';
import { ReceivingComponent } from '@app/modules/inventory/receiving/receiving.component';
import { FeatureGuard } from '@app/shared/guards';
import { FeatureFlagResolver } from '@app/shared/resolvers/feature-flag.resolver';
import { RfqSupplierSkusComponent } from 'v2/modules';
import { OrderTransferComponent } from 'v2/modules/order/components/order-transfer/order-transfer.component';

import { LocationComponent } from '../locations/location/location.component';

import { ArchivedRfqsComponent } from './archived-rfqs/archived-rfqs.component';
import { AdjustmentEntriesComponent } from './inventory/adjustment-entries/adjustment-entries.component';
import { AdjustmentEntryFormComponent } from './inventory/adjustment-entry-form/adjustment-entry-form.component';
import { ChannelShippingComponent } from './inventory/channel-shipping/channel-shipping.component';
import { GridStocksComponent } from './inventory/grid-stocks/grid-stocks.component';
import { InvListComponent } from './inventory/inv-list/inv-list.component';
import { RetailPricesComponent } from './inventory/retail-prices/retail-prices.component';
import { StocksComponent } from './inventory/stocks/stocks.component';
import { InventoryTransferOrderComponent } from './inventory-transfer-order/inventory-transfer-order.component';
import { NdProductPageComponent } from './new-designs/nd-product-page/nd-product-page.component';
import { NewProductPageComponent } from './new-product/new-product-page/new-product-page.component';
import { PriceNegotiationsComponent } from './price-negotiations/price-negotiations.component';
import { RequoteRequestsComponent } from './requote-requests/requote-requests.component';
import { RfqDetailsComponent } from './rfq-details/rfq-details.component';
import { RfqQuotationsComponent } from './rfq-quotations/rfq-quotations.component';
import { TransferOrderFormComponent } from './transfer-order-form/transfer-order-form.component';
import { TransferOrderViewComponent } from './transfer-order-view/transfer-order-view.component';

const routes :Routes = [
  { path: '', redirectTo: 'skus', pathMatch: 'full' },
  {
    path: ':id/quotations',
    component: RfqQuotationsComponent,
  },
  {
    path: ':id/view',
    component: RfqDetailsComponent,
    resolve: {
      featureFlags: FeatureFlagResolver,
    },
    data: {
      feature: EFeatureFlag.SUPPLIER_SOURCE_SKU,
      featureFlagKeys: {
        ftSupplierSourceSku: EFeatureFlag.SUPPLIER_SOURCE_SKU,
      },
    },
  },
  {
    path: 'adjustment-entries',
    component: AdjustmentEntriesComponent,
  },
  {
    path: 'adjustment-entries/create',
    component: AdjustmentEntryFormComponent,
  },
  {
    path: 'archived-rfqs',
    component: ArchivedRfqsComponent,
  },
  {
    path: 'channel-shipping',
    component: ChannelShippingComponent,
  },
  {
    path: 'defectives',
    component: DefectiveReportsComponent,
  },
  {
    path: 'grid-stocks',
    component: GridStocksComponent,
  },
  {
    path: 'inbound-shipments',
    loadChildren: () =>
      import('app/modules/inbound-shipments/inbound-shipments.module').then(
        (m) => m.InboundShipmentsModule,
      ),
  },
  {
    path: 'new-designs',
    component: NdProductPageComponent,
  },
  {
    path: 'new-designs/:id/view',
    component: NdProductPageComponent,
  },
  {
    path: 'new-products',
    component: NewProductPageComponent,
  },
  {
    path: 'price-negotiations',
    component: PriceNegotiationsComponent,
  },
  {
    path: 'purchase-orders/:id',
    component: EmptyComponent,
  },
  {
    path: 'receiving',
    component: ReceivingComponent,
  },
  {
    path: 'requote-requests',
    component: RequoteRequestsComponent,
  },
  {
    path: 'retail-prices',
    component: RetailPricesComponent,
  },
  {
    path: 's/:id',
    component: LocationComponent,
  },
  {
    path: 'skus',
    component: InvListComponent,
    resolve: {
      featureFlags: FeatureFlagResolver,
    },
    data: {
      featureFlagKeys: {
        ftSupplierSourceSku: EFeatureFlag.SUPPLIER_SOURCE_SKU,
      },
    },
  },
  {
    path: 'stocks',
    component: StocksComponent,
  },
  {
    path: 'supplier-sku',
    component: RfqSupplierSkusComponent,
    canActivate: [FeatureGuard],
    resolve: {
      featureFlags: FeatureFlagResolver,
    },
    data: {
      feature: EFeatureFlag.SUPPLIER_SOURCE_SKU,
      featureFlagKeys: {
        ftSupplierSourceSku: EFeatureFlag.SUPPLIER_SOURCE_SKU,
      },
    },
  },
  {
    path: 'transfer-order',
    component: InventoryTransferOrderComponent,
    children: [
      {
        path: 'list',
        component: OrderTransferComponent,
      },
      {
        path: 'create',
        component: TransferOrderFormComponent,
      },
      {
        path: ':id/edit',
        component: TransferOrderFormComponent,
      },
      {
        path: ':id',
        component: TransferOrderViewComponent, // note: standalone
      },
      {
        path: '**',
        redirectTo: 'list',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InventoryRoutingModule {}
